defineDs('DanskeSpil/Framework/AppUniverse/Scripts/AppUniverse/Helpers/AppDictionary',
  [
    'Shared/Framework/Mithril/Scripts/Helpers/Dictionary'
  ],
  function (Dictionary) {
    return new Dictionary('/AppUniverse');
  });
